import styled from 'styled-components';
import theme from '../../theme';

export const Card = styled.section`
  display: block;

  align-items: center;
  justify-content: space-between;
  margin-bottom: 13px;
  margin-top: 5px;
  padding: 10px;
  background-color: ${theme.colors.primary};
  border-radius: 10px;
  width: 100%;
  min-height: 250px;

  @media (max-width: 667px) {
    padding: 8px;
    margin-bottom: 10px;
    margin-top: 3px;
  }

  @media (max-width: 480px) {
    padding: 6px;
    margin-bottom: 8px;
  }
`;

export const CardTitle = styled.section`
  color: ${theme.colors.gray};
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 20px;
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  margin-left: 55px;
  margin-right: 60px;
  margin-bottom: 50px;

  border-radius: 10px;
  background-color: ${theme.colors.primary};

  align-items: center;
  color: ${theme.colors.title};

  h5 {
    margin-top: 18px;
    margin-bottom: 16px;
    font-weight: 800;
    font-size: 15px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    line-height: 1.4;

    @media (max-width: 1024px) {
      font-size: 14px;
      margin-top: 16px;
      margin-bottom: 14px;
      letter-spacing: 0.3px;
    }

    @media (max-width: 667px) {
      font-size: 13px;
      margin-top: 14px;
      margin-bottom: 12px;
      letter-spacing: 0.2px;
    }

    @media (max-width: 480px) {
      font-size: 12px;
      margin-top: 12px;
      margin-bottom: 10px;
    }
  }

  p {
    font-size: 15px;
    font-weight: 500;
    line-height: 1.7;
    text-align: center;
    margin-bottom: 20px;
    letter-spacing: 0.2px;
    max-width: 85%;

    @media (max-width: 1024px) {
      font-size: 14px;
      line-height: 1.6;
      max-width: 90%;
      margin-bottom: 18px;
    }

    @media (max-width: 667px) {
      font-size: 13px;
      line-height: 1.6;
      max-width: 95%;
      margin-bottom: 16px;
    }

    @media (max-width: 480px) {
      font-size: 12px;
      line-height: 1.55;
      max-width: 100%;
      margin-bottom: 14px;
    }

    a {
      font-weight: 700;
      transition: all 0.2s ease;
      
      &:hover {
        text-decoration: underline;
        opacity: 0.8;
      }
    }
  }

  @media (max-width: 1024px) {
    margin-left: 40px;
    margin-right: 40px;
    margin-bottom: 40px;
  }

  @media (max-width: 667px) {
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 20px;
    margin-bottom: 30px;
  }

  @media (max-width: 480px) {
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 16px;
    margin-bottom: 24px;
  }
`;
